import React from 'react';
import { connect } from 'react-redux';
import TooltipElement from '../components/tooltipElement';
import TooltipButtonGroup from '../components/tooltipButtonGroup';
import FeaturesTable from '../components/featuresTable';
import OverlayLoader from '../components/overlayLoader';
import * as featuresActions from '../store/featuresSlice';
import { featuresSelectors } from '../store/featuresSlice';
import * as ObjectDataActions from '../store/objectDataSlice';
import { objectDataNames, objectDataSelectors } from '../store/objectDataSlice';
import './common.css';
import setTitleToFilters from '../common/filtersTitles';

class FeaturesContainer extends React.Component {
  componentDidMount() {
    setTitleToFilters();
    this.props.fetchAllFeatureTypes();
    this.props.fetchAllFeatures();
  }

  render() {
    return (
      <OverlayLoader active={this.isLoading()} text={this.getLoaderMessage()}>
        <div>
          <h1>Features</h1>
          {this.renderButtons()}
          {this.renderContent()}
        </div>
      </OverlayLoader>
    );
  }

  renderButtons = () => (
    <TooltipButtonGroup>
      <TooltipElement
        type="button"
        text="Refresh"
        icon="refresh"
        onClick={() => {
          this.props.fetchAllFeatureTypes();
          this.props.fetchAllFeatures();
        }}
      />
    </TooltipButtonGroup>
  );

  renderContent = () => {
    if (this.props.featuresFetchingError)
      return this.renderError(this.props.featuresFetchingError.toString());
    return (
      <React.Fragment>
        {this.props.featureTypes.error
          ? this.renderError(this.props.featureTypes.error.toString())
          : null}
        <FeaturesTable
          features={this.props.features}
          featureTypes={this.props.featureTypes.data}
        />
      </React.Fragment>
    );
  };

  renderError = (message) => <p className="text-danger">Error: {message}</p>;

  isLoading = () =>
    this.props.isFeaturesFetching || this.props.featureTypes.isFetching;

  getLoaderMessage = () => {
    if (this.props.isFeaturesFetching) {
      return 'Features loading...';
    }
    if (this.props.featureTypes.isFetching) {
      return 'Feature types loading...';
    }
  };
}

const mapStateToProps = (state) => ({
  isFeaturesFetching: featuresSelectors.isFetching(state),
  features: featuresSelectors.selectAll(state),
  featuresFetchingError: featuresSelectors.fetchingError(state),

  featureTypes: objectDataSelectors.featureTypesState(state),
});

const actionCreators = {
  fetchAllFeatures: featuresActions.fetchAllFeatures,
  fetchAllFeatureTypes: () =>
    ObjectDataActions.fetchObjectData({
      objectName: objectDataNames.featureTypes,
    }),
};

export default connect(mapStateToProps, actionCreators)(FeaturesContainer);



// WEBPACK FOOTER //
// ./src/containers/featuresContainer.js